import React,{ useState, useRef } from 'react';
import AdminServiciosAPI from '../servicios/AdminServicios';
import { useParams } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import Config from '../comun/Config';
import { Toast } from 'primereact/toast';

const Cambiar = () => {
    const { acl } = useParams();
    const [clave, setClave] = useState('');
    const [clave2, setClave2] = useState('');
    const [cargando, setCargando] = useState(false);
    const toast = useRef(null);
    const [deshabilitar, setDeshabilitar] = useState(false);

    const cambiarClave = async () => {
        if(clave===clave2){
            setCargando(true);
            const response = await AdminServiciosAPI.postRegistro('cambiarClave',{acl:acl, clave:clave});
            if(response.ok){
                toast.current.show({severity:'success', summary: 'Reseteo de clave', detail:'Clave actualizada', sticky: true});
            }else{
                toast.current.show({severity:'error', summary: 'Error', detail:'Lo sentimos hubo un problema', sticky: true});
            }
            setDeshabilitar(true);
            setCargando(false);
        }else{
            toast.current.show({severity:'error', summary: 'Error', detail:'Por favor ingresa una clave idéndita en ambos campos', sticky: true});
        }
    }

    return (
        <div>
            <Toast ref={toast} position="bottom-center" />
            <h4>Resetear clave</h4>
            <p>Por favor ingresa tu nueva clave</p>
            <div className="p-field mb-4">
                <InputText id="in" className="w-100" value={clave} onChange={(e) => setClave(e.target.value)} placeholder="Ingrese su clave" />
            </div>
            <p>Por favor ingresa nuevamente tu nueva clave</p>
            <div className="p-field mb-4">
                <InputText id="in2" className="w-100" value={clave2} onChange={(e) => setClave2(e.target.value)} placeholder="Ingrese nuevamente su clave" />
            </div>
            <div className="d-flex justify-content-between">
                <Button disabled={clave2==='' || deshabilitar} className="boton-enviar w-50" label="Enviar" loading={cargando} onClick={cambiarClave} />
                <a className="mt-2" href={Config.dirroot}>Regresar al login</a>
            </div>
        </div>
    )
}

export default Cambiar